/**
 * Browser-safe unique id for local pins.
 */
export function createPinId() {
    if (globalThis.crypto?.randomUUID) {
        return globalThis.crypto.randomUUID();
    }

    return `pin-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}
